import {IServiceFactoryExtended} from '../../service-factory-extended.interface';
import {ILanguageSwitcherItem} from './language-switcher-item.interface';

export class LanguageSwitcherSection {
  constructor(private _services: IServiceFactoryExtended, private _title: string, private _fallbackTitleKey: string, private _items: ILanguageSwitcherItem[]) {

  }

  get title(): string {
    if(this._title) {
      return this._title;
    }

    return this._services.translation.translate(this._fallbackTitleKey);
  }

  get items(): ILanguageSwitcherItem[] {
    return this._items;
  }
}
